"use client";

import dynamic from "next/dynamic";
import { useSelector } from "react-redux";

import { getStore } from "@selectors/store";

const DefaultAdditionalItemsWidget = dynamic(
  () => import("@components/widgets/additional-items/default"),
);
const KitAdditionalItemsWidget = dynamic(() => import("@components/widgets/additional-items/kit"));

const DEFAULT_OBJ = {};

const AdditionalItemsWidget = (props) => {
  const store = useSelector(getStore);

  const { isKitShop } = store || DEFAULT_OBJ;

  return isKitShop ? (
    <KitAdditionalItemsWidget {...props} />
  ) : (
    <DefaultAdditionalItemsWidget {...props} />
  );
};

export default AdditionalItemsWidget;
